// @ts-check
import { QueryClient } from "@tanstack/react-query";

/**
 * @type {import('@tanstack/react-query').DefaultOptions}
 */
export const defaultOptions = {
  queries: {
    refetchOnWindowFocus: false,
    refetchInterval: false,
    retry: false,
  },
};

const queryClient = new QueryClient({
  defaultOptions,
});

export default queryClient;
